import Ajv from 'ajv'
import { AnnotationUserData } from '~/types/annotation'

const ajv = new Ajv()

const schema = {
  type: 'object',
  properties: {
    categoryId: { type: 'string' },
    items: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          title: { type: 'string' },
          description: { type: 'string' },
          children: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'string' },
                title: { type: 'string' },
                description: { type: 'string' },
              },
              required: ['id', 'title'],
            },
          },
        },
        required: ['id', 'title'],
      },
    },
  },
  required: ['categoryId', 'items'],
}

const validate = ajv.compile(schema)

export const validateAnnotationSquema = async (
  url: string | undefined
): Promise<AnnotationUserData | boolean> => {
  if (!url) return false
  try {
    const response = await fetch(url)
    const data = await response.json()
    const isValid = validate(data)
    if (isValid) {
      return data as AnnotationUserData
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}
